import '../style/Home.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container } from 'react-bootstrap';
import SupervisorProfile from './SupervisorProfile';
import SupervisorStudy from './SupervisorStudy';
import { AuthContext } from '../App';
import React from 'react';


const Supervisor = () => {

    const { state: authState, dispatch: authDispatch } = React.useContext(AuthContext);
    // console.log('Load trainee results:', authState.user);
    // console.log('Number of studies: ', authState.user.studies.length);

    return (
        <Container className="container">
            <Tabs
                defaultActiveKey="supervisor-profile"
                id="supervisor-results-tabs"
                className="mb-3"
                variant='tabs'
            >
                <Tab eventKey="supervisor-profile" key="supervisor-profile" title={"Profile "+authState.user.name}>
                    <SupervisorProfile user={ authState.user }  ></SupervisorProfile>
                </Tab>

                {authState.user.studies.map((iStudy) => (
                    <Tab eventKey={iStudy.studyName} key={iStudy.studyName} title={"Study " + iStudy.studyName}>
                        <SupervisorStudy eventKey={authState.user.id+iStudy.studyName+'Results'} key={authState.user.id+iStudy.studyName+'Results'} study={iStudy} user={authState.user} ></SupervisorStudy>
                    </Tab>
                )
                )}

            </Tabs>
        </Container>
    );
}

export default Supervisor;